import _matches from "lodash/matches";
import _isNumber from "lodash/isNumber";
import invariant from 'invariant';
export function findElement(elements, idOrPath) {
  const matcher = _matches(typeof idOrPath === 'string' ? {
    id: idOrPath
  } : idOrPath);
  return elements.reduce((found, element) => {
    if (found) {
      return found;
    }
    if (matcher(element)) {
      return element;
    }
    if (element.elementType === 'fieldGroupInstance') {
      return findElement(element.elements || [], idOrPath);
    }
    return null;
  }, null);
}
export function findField(elementDefinitions, idOrPath) {
  const matcher = _matches(typeof idOrPath === 'string' ? {
    id: idOrPath
  } : idOrPath);
  return elementDefinitions.reduce((found, elementDefinition) => {
    if (found) {
      return found;
    }
    if (matcher(elementDefinition)) {
      return elementDefinition;
    }
    if (elementDefinition.elementType === 'fieldGroupDefinition') {
      return findField(elementDefinition.elementDefinitions, idOrPath);
    }
    return null;
  }, null);
}
export function findDecisionButtonsDefinition(elementDefinitions) {
  const possibleMatch = elementDefinitions.find(elementDefinition => {
    if (elementDefinition.elementType === 'fieldGroupDefinition') {
      return false;
    }
    return elementDefinition.asButtons;
  });
  if (!possibleMatch) {
    return null;
  }
  invariant(possibleMatch.elementType === 'fieldDefinition', `The decision buttons field can only be a "fieldDefinition". Found "${possibleMatch.elementType}" instead.`);
  return possibleMatch;
}
export function findFieldPosition(elementDefinitions, id) {
  return elementDefinitions.findIndex(element => element.id === id);
}
export function addField(elementDefinitions, elementDefinition, position) {
  const newPosition = _isNumber(position) && position < elementDefinitions.length ? position : elementDefinitions.length;
  return [...elementDefinitions.slice(0, newPosition), elementDefinition, ...elementDefinitions.slice(newPosition)];
}
export function replaceElement(elements, newElement) {
  return elements.map(element => {
    if (element.id === newElement.id) {
      return newElement;
    }
    if (element.elementType === 'fieldGroupInstance') {
      return {
        ...element,
        elementType: 'fieldGroupInstance',
        elements: replaceElement(element.elements || [], newElement)
      };
    }
    return element;
  });
}
export function findParent(elementDefinitions, elementDefinitionId, currentParent) {
  return elementDefinitions.reduce((found, elementDefinition) => {
    if (found) {
      return found;
    }
    if (elementDefinition.id === elementDefinitionId) {
      return currentParent;
    }
    if (elementDefinition.elementType === 'fieldGroupDefinition') {
      return findParent(elementDefinition.elementDefinitions, elementDefinitionId, elementDefinition);
    }
    return null;
  }, null);
}